import { FunctionComponent, useEffect, useRef } from "react";

interface BasicProgressProps {
  percent: number;
  label?: string;
}

const BasicProgress: FunctionComponent<BasicProgressProps> = ({
  percent,
  label,
}) => {
  const progressBarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Dynamically update the width via the CSSOM
    if (progressBarRef.current) {
      progressBarRef.current.style.width = `${percent}%`;
    }
  }, [percent]);

  return (
    <div className="app-progress" data-test="progress-bar">
      <div ref={progressBarRef} className="progress-bar">
        <span className="progress-label">{label ? label : `${percent}%`}</span>
      </div>
    </div>
  );
};

export default BasicProgress;
